import * as React from 'react';

import {Card} from "@mui/material";
import {styled} from "@mui/material/styles";

const StyledCard = styled(Card)(({ theme }) => ({
    border: '1px solid #eeecec',
    '& .MuiCardHeader-root': {
        position: 'relative',
        '& .MuiLinearProgress-root': {
            position: 'absolute',
            bottom: 0,
            left: 0,
        },
        '& .MuiCardHeader-title': {
            [theme.breakpoints.down('sm')]: {
                display: 'none',
            },
            [theme.breakpoints.up('sm')]: {
                display: 'block',
            },
            fontSize: '1.2rem',
            fontWeight: 400,
        },
        '& .MuiCardHeader-avatar': {
            marginRight: 0,
        },
    },
    '& .MuiCardContent-root': {
        '& .MuiTableContainer-root': {
            marginTop: theme.spacing(2),
            '& .MuiTable-root': {
                '& .MuiTableHead-root': {
                    '& .MuiTableRow-root': {
                        '& .MuiTableCell-root': {
                            fontWeight: 600,
                            fontSize: '0.7rem',
                        },
                    },
                },
                '& .MuiTableBody-root': {
                    '& .MuiTableRow-root': {
                        '& .MuiTableCell-root': {
                            fontSize: '0.8rem',
                            '& .MuiAvatar-root': {},
                            '& .employee_name': {
                                fontSize: '0.8rem',
                                fontWeight: 600,
                            },
                            '& .employee_code': {
                                fontSize: '0.8rem',
                                fontWeight: 400,
                            },
                        },
                    },
                },
                '& .MuiTableFooter-root': {},
            },
        },
        
    },
    '& .MuiCardActions-root': {
        padding: theme.spacing(3),
        width: '100%',
        justifyContent: 'space-between',
    }
}));


export const SettingSidebarCard = ({children, props, styles}) => {

    return (
        <StyledCard {...props} {...styles}>
            {children}
        </StyledCard>
    )
}